/* eslint-disable */
import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tooltip from '../../common/Tooltip';
import SelectTimePicker from './SelectTimePicker';
import { EditIcon } from './BookingStartTimeWidget';
import {getRelevantJobId} from "../../../utils";

const formatNumber = n => (n > 9 ? n : `0${n}`);

const propTypes = {
    job: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired,
    enableModal: PropTypes.bool,
    enableLinkToModal: PropTypes.bool,
    isPreviewMode: PropTypes.bool,
};

class BookingEndTimeWidget extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { job } = this.props;
        const effectiveDatetimeFinished =
            job.booking && job.booking.datetime_finished
                ? moment(job.booking.datetime_finished)
                : null;
        const originalDatetimeFinished = moment(job.end_datetime);
        const clockin = job.booking ? job.booking.clock_in : null;
        const clockout = job.booking ? job.booking.clock_out : null;
        const passedClockOutTime =
            moment(originalDatetimeFinished).add(3, 'hours') < moment();
        let color = '#000000';
        let timeTooltipMessage = 'Planned finish time';
        let iconTooltipMessage;
        let iconClass;
        const clockedOutLate = false;

        // Computing time tooltip
        if (
            effectiveDatetimeFinished &&
            effectiveDatetimeFinished.valueOf() !=
                originalDatetimeFinished.valueOf()
        ) {
            color = '#FF8C00';
            const timeDiff = moment.duration(
                effectiveDatetimeFinished.diff(originalDatetimeFinished),
            );
            const lateOrEarly = timeDiff < 0 ? 'earlier' : 'later';
            const hoursDiff = Math.abs(timeDiff.hours());
            const minutesDiff = formatNumber(Math.abs(timeDiff.minutes()));

            if (hoursDiff >= 1) {
                timeTooltipMessage = `Finished ${hoursDiff}h ${minutesDiff}m ${lateOrEarly}`;
            } else {
                timeTooltipMessage = `Finished ${minutesDiff}m ${lateOrEarly}`;
            }
        } else if (effectiveDatetimeFinished) {
            color = '#006400';
            timeTooltipMessage = 'Finished on time';
            iconClass = 'icon-check-circle-22 confirm-icon';
        }

        // Computing icon and tooltip
        if (clockout) {
            iconClass = 'icon-check-circle-2 confirm-icon';
            iconTooltipMessage = `Clocked-out at ${moment(
                clockout.clocking_time,
            ).format('HH:mm')}`;

            if (clockout.pending && effectiveDatetimeFinished) {
                iconClass = null;
            } else if (clockout.pending) {
                iconClass = 'icon-warning warning-icon';
                iconTooltipMessage = 'The freelancer clocked-out later';
            } else if (clockout.overridden) {
                iconClass = 'icon-check-circle-22 confirm-icon';
                iconTooltipMessage = `Manually Clocked out at ${moment(
                    clockout.clocking_time,
                ).format('HH:mm')} by ${clockout.author}`;
            }
        } else if (passedClockOutTime && !effectiveDatetimeFinished) {
            iconClass = 'icon-warning warning-icon';
            iconTooltipMessage =
                'The freelancer did not clock-out for the shift';
        }

        // Cancelled bookings
        if (['CA', 'FC', 'NS', 'BC'].indexOf(job.booking.status) >= 0) {
            if (!effectiveDatetimeFinished) {
                iconClass = 'icon-error error-icon';
                iconTooltipMessage = 'Effective end time missing';
            } else {
                iconClass = null;
            }
            return (
                <span className="time-container">
                    <Tooltip tooltip="Effective end time">
                        <span className="stale">
                            {effectiveDatetimeFinished
                                ? effectiveDatetimeFinished.format('HH:mm')
                                : 'N/A'}
                        </span>
                    </Tooltip>
                    <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                        <i className={`icon ${iconClass}`} />
                    </Tooltip>
                </span>
            );

            // Bookings settled
        }
        if (effectiveDatetimeFinished) {
            if (this.props.isPreviewMode || !this.props.enableLinkToModal) {
                return (
                    <span className="time-container">
                        <Tooltip tooltip={timeTooltipMessage}>
                            <span style={{ color }}>
                                {effectiveDatetimeFinished.format('HH:mm')}
                            </span>
                        </Tooltip>
                        <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                            <i className={`icon ${iconClass}`} />
                        </Tooltip>
                    </span>
                );
            }
            return (
                <span className="select-time-container">
                    <SelectTimePicker
                        apiFieldName="datetime_finished"
                        value={effectiveDatetimeFinished.toISOString()}
                        jobId={getRelevantJobId(job)}
                        bookingId={job.booking.id}
                        notification={this.props.notification}
                        color={color}
                        tooltipMessage={timeTooltipMessage}
                        table={this.props.table}
                    />
                    <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                        <i className={`icon ${iconClass}`} />
                    </Tooltip>
                    <EditIcon />
                </span>
            );

            // Bookings requiring resolution
        }
        if (
            (clockout && clockout.pending) ||
            (!clockout && passedClockOutTime)
        ) {
            if (this.props.enableLinkToModal) {
                return (
                    <NavLink
                        style={{
                            color,
                            fontWeight: '300',
                        }}
                        className="time-container"
                        to={`${this.props.location.pathname}clockin-out/${job.booking.id}${this.props.location.search}`}
                    >
                        <Tooltip tooltip={timeTooltipMessage}>
                            <span>
                                {originalDatetimeFinished.format('HH:mm')}
                            </span>
                        </Tooltip>
                        <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                            <i className={`icon ${iconClass}`} />
                        </Tooltip>
                    </NavLink>
                );
            }

            return (
                <span className="time-container">
                    <Tooltip tooltip={timeTooltipMessage}>
                        <span style={{ color }}>
                            {originalDatetimeFinished.format('HH:mm')}
                        </span>
                    </Tooltip>
                    <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                        <i className={`icon ${iconClass}`} />
                    </Tooltip>
                </span>
            );

            // Unsettled bookings (ongoing / future)
        }
        return (
            <span className="time-container">
                <Tooltip tooltip={timeTooltipMessage}>
                    <span style={{ color }}>
                        {originalDatetimeFinished.format('HH:mm')}
                    </span>
                </Tooltip>
                <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                    <i className={`icon ${iconClass}`} />
                </Tooltip>
            </span>
        );
    }
}

BookingEndTimeWidget.propTypes = propTypes;

export default withRouter(BookingEndTimeWidget);
